import { EmptyStateWithText } from 'components/EmptyState';
import React from 'react';
import styled from 'styled-components';

const Title = styled.h1`
  padding: 16px 0;
  margin-right: 10.5px;
  font-weight: normal;
  font-size: 24px;
  line-height: 36px;
  color: #000000;
`;

const ComingSoon: React.VFC<{ title: string }> = ({ title }) => (
  <div>
    <Title>{title}</Title>
    <EmptyStateWithText text="Coming soon..." />
  </div>
);

export default ComingSoon;
